import styled from "@mui/material/styles/styled";
import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export const LoginPageContainer = styled(Box)(() => ({
  display: "flex",
  width: "100%",
}));

export const LoginFormContainer = styled(Box)(() => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  maxWidth: "460px",
}));

export const LoginTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "48px",
  fontStyle: "normal",
  textAlign: "center",
  fontWeight: 600,
  lineHeight: "62px",
  marginTop: "150px",
  marginBottom: "16px",
}));

export const LoginSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: "center",
  fontFamily: "Sora",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "32px",
  marginBottom: "44px",
  width: "460px",
}));

export const LoginLink = styled(RouterLink)(({ theme }) => ({
  color: theme.palette.primary.main,
  textAlign: "center",
  fontFamily: "Nunito",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "20px",
  textTransform: "capitalize",
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline",
  },
}));

export const PolicyLinksContainer = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "24px",
  marginTop: "24px",
  flexWrap: "nowrap",
  whiteSpace: "nowrap",
}));

export const PolicyLink = styled("a")(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: "13px",
  fontFamily: "Nunito",
  fontWeight: 400,
  textDecoration: "none",
  lineHeight: "20px",
  "&:hover": {
    color: theme.palette.text.primary,
    textDecoration: "underline",
  },
}));
